import PropTypes from 'prop-types';
import { useState } from 'react';
import Modal from '../../../Modal';
import { SearchStatus, TravelTypes, LocationTypes } from '../../../../constants';
import FlightItinerary from '../../FlightInformation/FlightItinerary';
import HotelItinerary from '../../HotelInformation/HotelItinerary';
import CarItinerary from '../../CarsInformation/CarItinerary';
import HotelInformation from '../../HotelInformation';
import FlightInformation from '../../FlightInformation';
import CarsInformation from '../../CarsInformation';
import CruiseInformation from '../../CruiseInformation';
import CruiseDetails from '../../CruiseDetails';
import withSpinner from '../../../../HOCs/withSpinner';

const AgentTip = ({
  agentTip,
  tripId,
  departureCityId,
  cruiseDepartDate,
  handleViewCabinsClick,
  handleCloseCruiseModal,
  itineraryDepartCity,
}) => {
  const [isModalOpen, setIsModalOpen] = useState({});
  const handleViewModalClick = (mode) => {
    if (typeof mode === 'number') {
      const obj = {};
      obj[mode] = true;
      setIsModalOpen(obj);
    } else {
      setIsModalOpen({});
      if (handleCloseCruiseModal) {
        handleCloseCruiseModal();
      }
    }
  };

  const handleViewCruiseCabinsClick = (itineraryId) => {
    handleViewModalClick(TravelTypes.cruise);
    if (handleViewCabinsClick) {
      handleViewCabinsClick(itineraryId);
    }
  };

  return (
    <div className="mb-3 border border-grey-500 border-opacity-20 rounded-tl-none rounded-tr-none rounded-md w-full">
      {agentTip.itineraries.map((itinerary) => (
        <div className="py-3 px-4" key={`${itinerary.startDateTime}${itinerary.mode}`}>
          {itinerary.mode === TravelTypes.flight && (
            <>
              <span className="text-xl font-medium">Suggested Flight</span>
              <FlightItinerary itinerary={itinerary} tripId={tripId} />
              <a
                className="font-medium text-theme cursor-pointer"
                tabIndex="-1"
                role="button"
                onClick={() => handleViewModalClick(TravelTypes.flight)}
                onKeyPress={() => handleViewModalClick(TravelTypes.flight)}
              >
                View other flights {itinerary.formattedAirportsString}
              </a>
              {isModalOpen[TravelTypes.flight] && (
                <FlightInformation
                  tripId={tripId}
                  flightItinerary={itinerary}
                  doShowAsModalOnly
                  onModalClose={handleViewModalClick}
                />
              )}
            </>
          )}
          {itinerary.mode === TravelTypes.hotel && (
            <>
              {withSpinner(
                () => (
                  <>
                    <span className="text-xl font-medium">Suggested Hotel</span>
                    <HotelItinerary itinerary={itinerary} tripId={tripId} />
                    {itinerary.searchGeoname && (
                      <a
                        className="font-medium text-theme cursor-pointer"
                        tabIndex="-1"
                        role="button"
                        onClick={() => handleViewModalClick(TravelTypes.hotel)}
                        onKeyPress={() => handleViewModalClick(TravelTypes.hotel)}
                      >
                        View other hotels (near {itinerary.searchGeoname.name})
                      </a>
                    )}
                    {isModalOpen[TravelTypes.hotel] && (
                      <HotelInformation
                        tripId={tripId}
                        defaultDepartureCityId={departureCityId}
                        departureCityName={itineraryDepartCity}
                        defaultCruiseDepartDate={cruiseDepartDate}
                        checkInDate={itinerary.startDateTime}
                        checkOutDate={itinerary.endDateTime}
                        searchDestination={itinerary.searchGeoname}
                        doShowAsModalOnly
                        onModalClose={handleViewModalClick}
                      />
                    )}
                  </>
                ),
                agentTip.hotelStatus === SearchStatus.SEARCHING,
                'Loading suggested hotel...',
                'inline',
                'xs',
              )}
            </>
          )}
          {itinerary.mode === TravelTypes.carrental && (
            <>
              <span className="text-xl font-medium">Suggested Rental car</span>
              <CarItinerary selectedCarDestination={0} itinerary={itinerary} tripId={tripId} />
              <a
                className="font-medium text-theme cursor-pointer"
                tabIndex="-1"
                role="button"
                onClick={() => handleViewModalClick(TravelTypes.carrental)}
                onKeyPress={() => handleViewModalClick(TravelTypes.carrental)}
              >
                View other cars (pickup:{' '}
                {itinerary.originGeoname.iata || itinerary.originGeoname.name}, dropoff:{' '}
                {itinerary.destinationGeoname.iata || itinerary.destinationGeoname.name})
              </a>
              {isModalOpen[TravelTypes.carrental] && (
                <CarsInformation
                  tripId={tripId}
                  dropoffCode={{
                    value:
                      'iata' in itinerary.originGeoname
                        ? itinerary.originGeoname.iata
                        : itinerary.originGeoname.departureCityId,
                    label: itinerary.originGeoname.name,
                    group: 'iata' in itinerary.originGeoname ? 'Airports' : 'Port of departure',
                    locationType:
                      'iata' in itinerary.originGeoname
                        ? LocationTypes.AIRPORT
                        : LocationTypes.PORT_OF_DEPARTURE,
                    airportCode:
                      'iata' in itinerary.originGeoname ? itinerary.originGeoname.iata : null,
                  }}
                  pickupCode={{
                    value:
                      'iata' in itinerary.destinationGeoname
                        ? itinerary.destinationGeoname.iata
                        : itinerary.destinationGeoname.departureCityId,
                    label: itinerary.destinationGeoname.name,
                    group:
                      'iata' in itinerary.destinationGeoname ? 'Airports' : 'Port of departure',
                    locationType:
                      'iata' in itinerary.destinationGeoname
                        ? LocationTypes.AIRPORT
                        : LocationTypes.PORT_OF_DEPARTURE,
                    airportCode:
                      'iata' in itinerary.destinationGeoname
                        ? itinerary.destinationGeoname.iata
                        : null,
                  }}
                  pickupDateTime={itinerary.pickUpDateTime}
                  returnDateTime={itinerary.dropOffDateTime}
                  doShowAsModalOnly
                  onModalClose={handleViewModalClick}
                />
              )}
            </>
          )}
          {itinerary.mode === TravelTypes.cruise && (
            <>
              <span className="text-xl font-medium">Suggested Cruise:</span>
              <CruiseInformation
                isInsideModal={false}
                selectedItineraryRow={itinerary.travelOption.itineraryRows[0]}
                handleViewCabinsClick={() =>
                  handleViewCruiseCabinsClick(itinerary.travelOption.itineraryRows[0].itineraryId)
                }
                cruiseOption={itinerary.travelOption}
              />
              <Modal
                open={(isModalOpen || {})[TravelTypes.cruise] || false}
                onClose={handleViewModalClick}
              >
                <div>
                  <div className="px-8 grid grid-flow-col auto-cols-max gap-5 font-bold border-b-2">
                    <a
                      role="button"
                      tabIndex="-1"
                      className="text-theme border-b-2 border-theme py-4 w-24 text-center"
                    >
                      Cruise
                    </a>
                  </div>
                  <CruiseInformation
                    isInsideModal
                    selectedItineraryRow={itinerary.travelOption.itineraryRows[0]}
                    cruiseOption={itinerary.travelOption}
                  />
                  <CruiseDetails
                    itineraryId={itinerary.travelOption.itineraryRows[0].itineraryId}
                    onModalClose={handleViewModalClick}
                    selectedItineraryRow={{
                      ...itinerary.travelOption.itineraryRows[0],
                      travelOption: itinerary.travelOption,
                    }}
                  />
                </div>
              </Modal>
            </>
          )}
        </div>
      ))}
      {agentTip.flightStatus === SearchStatus.SEARCHING && (
        <div className="py-3 px-4">
          <>
            {withSpinner(
              () => (
                <></>
              ),
              agentTip.flightStatus === SearchStatus.SEARCHING,
              'Loading suggested flight...',
              'inline',
              'xs',
            )}
          </>
        </div>
      )}
    </div>
  );
};

AgentTip.propTypes = {
  tripId: PropTypes.string.isRequired,
  agentTip: PropTypes.shape({
    itineraries: PropTypes.arrayOf(PropTypes.shape({})),
    betterFlight: PropTypes.shape({}),
    hotelStatus: PropTypes.number,
    flightStatus: PropTypes.number,
  }),
  departureCityId: PropTypes.number.isRequired,
  cruiseDepartDate: PropTypes.string.isRequired,
  itineraryDepartCity: PropTypes.string.isRequired,
  handleViewCabinsClick: PropTypes.func,
  handleCloseCruiseModal: PropTypes.func,
};

AgentTip.defaultProps = {
  agentTip: {
    itineraries: [],
    betterFlight: null,
    hotelStatus: null,
    flightStatus: null,
  },
  handleViewCabinsClick: undefined,
  handleCloseCruiseModal: undefined,
};

export default AgentTip;
